// Check that the length of the first and last names combined is at most 29 characters
const maxNameLength = (value, allValues) => {
	const firstNameLength = allValues.firstName === undefined ? 0 : allValues.firstName.length;
	const lastNameLength = allValues.lastName === undefined ? 0 : allValues.lastName.length;
	// STORIS combines all name elements for the full name and separates them with spaces
	// This logic is in FM.CUSTOMER1.SUB's FullName subroutine.
	return firstNameLength + lastNameLength > 29
		? 'Full Name must be at most 29 characters'
		: undefined;
};

export default maxNameLength;
